import axios from "axios";

const _raw = process.env.REACT_APP_API_URL || "http://localhost:8000";
const BASE_URL = _raw.replace(/\/api\/?$/, "");

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
    };
};

export const fetchDeliveryConfig = async () => {
    const res = await axios.get(`${BASE_URL}/api/admin/delivery/config`, {
        headers: getAuthHeaders()
    });
    return res.data;
};

export const updateDeliveryConfig = async (config) => {
    const res = await axios.patch(`${BASE_URL}/api/admin/delivery/config`, config, {
        headers: getAuthHeaders()
    });
    return res.data;
};

export const fetchDeliveryJobs = async (params = {}) => {
    const res = await axios.get(`${BASE_URL}/api/delivery/jobs`, {
        params,
        headers: getAuthHeaders()
    });
    return res.data;
};

export const fetchRestaurantDrivers = async () => {
    const res = await axios.get(`${BASE_URL}/api/delivery/drivers`, {
        headers: getAuthHeaders()
    });
    return res.data;
};

export const createDeliveryJob = async (orderId) => {
    const res = await axios.post(`${BASE_URL}/api/delivery/jobs/create?order_id=${orderId}`, {}, {
        headers: getAuthHeaders()
    });
    return res.data;
};

export const assignDriver = async (jobId, driverId) => {
    const res = await axios.post(`${BASE_URL}/api/delivery/jobs/${jobId}/assign?driver_id=${driverId}`, {}, {
        headers: getAuthHeaders()
    });
    return res.data;
};

export const autoAssignDriver = async (jobId) => {
    const res = await axios.post(`${BASE_URL}/api/delivery/jobs/${jobId}/auto-assign`, {}, {
        headers: getAuthHeaders()
    });
    return res.data;
};
export const settleRiderPayouts = async (driverId) => {
    const res = await axios.post(`${BASE_URL}/api/admin/delivery/settle/${driverId}`, {}, {
        headers: getAuthHeaders()
    });
    return res.data;
};
